<template>
  <p>
    🚨 You do not have permission to see payment information. Please contact
    <span data-test-id="billing-admins">{{ getBillingAdmins }}</span> to get
    permission to view and edit your organizations’s payment information.
  </p>
</template>
<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';

const userCollection = StoreModuleMap[ItemTypeConsts.user];

export default {
  name: 'UserLockNoBillingPermissions',

  computed: {
    ...mapGetters(userCollection, {
      users: 'getCollection',
    }),

    getBillingAdmins() {
      return this.users
        .filter(
          ({ roleName }) => roleName && roleName.indexOf('Administrator With Billing') !== -1,
        )
        .map(({ email }) => email)
        .join(', ');
    },
  },

  async created() {
    try {
      await this.fetchCollection();
    } catch (error) {
      notify('error', 'Unable to fetch collection');
    }
  },

  methods: mapActions(userCollection, ['fetchCollection']),
};
</script>
